<template>
    <div v-title :data-title="title" style="padding: 15px;" >
        <ol>
            <p  style="text-align: center;font-size: 20px; font-weight: 600;">用户协议</p>
            <li>
                <p>概述<br>
                    本用户协议（以下简称“本协议”）适用于 北京安宇润科技有限公司 运营和管理（以下简称“我们”，“本公司”）旗下的大部分产品与服务（以下简称“本产品”），如果某项产品与服务有单独的服务规则，则该产品的服务规则优先适用。本协议是您（个人或单一实体）与本公司之间就使用本产品达成的具有法律约束力的法律协议。<br><br>
                    请您在使用本产品之前仔细阅读下列条款。您下载、安装或使用产本品或者单击“ 我同意”表明您已经阅读本协议并充分理解、遵守本协议所有条款，包括涉及免除或者限制本公司责任的免责条款、用户权利限制条款、约定争议解决方式等，这些条款均用粗体字标注。如果您不同意本协议的全部或部分内容，请不要下载、安装和使用本产品。
                </p>
            </li>
            <li>
                <p>权利声明<br>
                    本公司拥有“本产品”的所有权和知识产权等全部权利。本产品受中国及其他国家的知识产权法、国际知识产权公约（包括但不限于著作权法、商标法、专利法等）的保护。所有未授予您的权利均被本公司保留，您不可以从本产品上移除本公司的版权标记或其他权利声明。<br><br>
                    您确定不享有本软件的所有权，本软件未被出售给用户，本公司保留本软件的所有权。
                </p>
            </li>
            <li>
                <p>授权许可<br>
                    本公司授予您一项非排他的、不可转让的、非商业性的、可撤销的许可，以下载、安装、备份和使用本产品。本公司授予您仅出于个人非商业目在移动设备上使用本产品，如果您希望将本产品用于其他非本公司授权的目的或其他商业目的，您必须另行取得本公司的单独书面许可。<br><br>
                    除非就某些第三方软件软件有明文规定或适用法律允许，否则您不得在未取得本公司书面许可的情况下修改、翻译、反向汇编、反向工程、反编译本软件的部分或全部。
                </p>
            </li>
            <li>
                <p>用户行为<br>

                    如果您在使用本公司产品或服务的过程中发布相关用户内容，您需要对自己发布的所有用户内容负责。用户内容是指您发布或以其他方式使用本产品时产生的所有内容（例如：您的信息、声音、图片或其他内容）。您是您的用户内容唯一的责任人，您将承担因您的用户内容违法法律、侵犯第三方权益的所有法律责任。<br><br>

                    在使用过程中，您将承担因下述行为而产生的全部法律责任，本公司不对您的下述行为承担任何责任：<br>
                    破坏宪法所确定的基本原则的；<br>
                    危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；<br>
                    损害国家荣誉和利益的；<br>
                    煽动民族仇恨、民族歧视，破坏民族团结的；<br>
                    破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
                    散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
                    散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
                    侮辱或者诽谤他人，侵害他人合法权益的；<br>
                    含有法律、行政法规禁止的其他内容的。<br>
                </p>

            </li>
            <li>
                <p>功能的调整、改进与升级<br>
                    我们可能对产品进行不时地调整、改进和增减，甚至下线我们部分产品，以不断适应我们的运营需要。任何本产品的更新版本或未来版本或者其他变更同样受到本协议约束。
                </p>
            </li>
            <li>
                <p>不可抗力与责任限制<br>
                    不可抗力：本协议有效期间，如若遭受不可抗力事件，任何一方可暂行中止履行本协议项下的义务直至不可抗力事件的影响消除，并且遭受方无需为此承担违约责任，但应及时将不可抗力事件及时通知对方，并尽最大努力克服该事件，减少损失的扩大。不可抗力指各方不能控制、不可预见或即使预见亦无法避免的事件且该事件足以妨碍、影响或延误任何一方根据本协议履行其全部或部分义务。该事件包括但不限于自然灾害、战争、法律法规变更、政府命令、计算机病毒、黑客攻击或基础电信运营商服务中断等。</br>
                    损害限制：本公司及其分支，和所属的管理人员、董事、合伙人、雇员、承包商给你造成的所有损害赔偿额度均仅限于你使用产品支付的款额。你放弃对特殊、间接、附带或间接损害要求赔偿的权利，包括并不限于利润损失、收入、使用、或数据和应用的损失，即使本公司知道此类损失的可能性。
                </p>
            </li>
            <li>
                <p>个人信息保护<br>
                    保护用户跟个人信息安全、维护用户隐私是我们一贯的理念，并且我们贯穿于所有产品或服务的立项、开发和运营过程。为不断优化用户体验，向用户提供更加个性化、智能化的内容与服务，我们会收集您的个人信息与非个人信息。您在使用特定的产品时，可以查看关于该产品的隐私说明以及我们的《隐私政策》，了解关于我们收集信息的内容、使用目的以及如何保护你的信息安全，该《隐私政策》均构成本协议的一部分
                </p>
            </li>
            <li>
                <p>联系我们<br>如您对本协议及隐私政策相关事宜有任何问题、意见或建议，您可邮箱联系我们：3985841@qq.com。</p>
            </li>

        </ol>
    </div>
</template>

<script>
    export default {
        name:'Agreement',
        data() {
            return {
                title: '用户协议'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Agreement.vue